/**
 * @generated SignedSource<<55df2f4983e3bc1dfa4aac2a1aeec84c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type IntegrationModalQuery$variables = {
  companyId: string;
};
export type IntegrationModalQuery$data = {
  readonly companyById: {
    readonly integrations: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly rowId: any;
          readonly config: any | null;
          readonly kind: string;
        };
      }>;
    };
    readonly " $fragmentSpreads": FragmentRefs<"Integrations_company" | "PlaidIntegrations_company" | "StripeIntegration_company">;
  } | null;
};
export type IntegrationModalQuery = {
  variables: IntegrationModalQuery$variables;
  response: IntegrationModalQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "companyId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "companyId"
  }
],
v2 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 100
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rowId",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "config",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "kind",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "IntegrationModalQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Company",
        "kind": "LinkedField",
        "name": "companyById",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "Integrations_company"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "PlaidIntegrations_company"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "StripeIntegration_company"
          },
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "IntegrationsConnection",
            "kind": "LinkedField",
            "name": "integrations",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "IntegrationsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Integration",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v4/*: any*/),
                      (v5/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "integrations(first:100)"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "IntegrationModalQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Company",
        "kind": "LinkedField",
        "name": "companyById",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "IntegrationsConnection",
            "kind": "LinkedField",
            "name": "integrations",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "IntegrationsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Integration",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      (v3/*: any*/),
                      (v5/*: any*/),
                      (v4/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "status",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__typename",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "cursor",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endCursor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasNextPage",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "integrations(first:100)"
          },
          {
            "alias": null,
            "args": (v2/*: any*/),
            "filters": null,
            "handle": "connection",
            "key": "Integrations_integrations",
            "kind": "LinkedHandle",
            "name": "integrations"
          },
          {
            "alias": null,
            "args": (v2/*: any*/),
            "filters": null,
            "handle": "connection",
            "key": "PlaidIntegrations_integrations",
            "kind": "LinkedHandle",
            "name": "integrations"
          },
          {
            "alias": null,
            "args": (v2/*: any*/),
            "filters": null,
            "handle": "connection",
            "key": "StripeIntegration_integrations",
            "kind": "LinkedHandle",
            "name": "integrations"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "346daec5d70b85e683848f27ed0df73e",
    "id": null,
    "metadata": {},
    "name": "IntegrationModalQuery",
    "operationKind": "query",
    "text": "query IntegrationModalQuery(\n  $companyId: ID!\n) {\n  companyById(id: $companyId) {\n    ...Integrations_company\n    ...PlaidIntegrations_company\n    ...StripeIntegration_company\n    integrations(first: 100) {\n      edges {\n        node {\n          rowId\n          config\n          kind\n          id\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment Integrations_company on Company {\n  id\n  integrations(first: 100) {\n    edges {\n      node {\n        id\n        rowId\n        kind\n        config\n        status\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment PlaidIntegrations_company on Company {\n  integrations(first: 100) {\n    edges {\n      node {\n        id\n        rowId\n        kind\n        status\n        config\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n\nfragment StripeIntegration_company on Company {\n  integrations(first: 100) {\n    edges {\n      node {\n        id\n        rowId\n        kind\n        status\n        config\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n"
  }
};
})();

(node as any).hash = "538f6e2882000a5d8a749759dc5bd3fc";

export default node;
